import React from 'react';
import {SvgIcon} from '@material-ui/core';

export default function FacebookIcon() {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" >
            <g fill="none" fillOpacity=".2" fillRule="evenodd">
                <g fill="#FFF">
                    <g>
                        <g>
                            <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm1.67 5c-2.016 0-3.392 1.23-3.392 3.486v1.943H8v2.635h2.278v6.856H13v-6.856h2.27l.34-2.635H13V8.745c0-.761.211-1.281 1.306-1.281l1.398-.004V5.106C15.46 5.073 14.63 5 13.67 5z" transform="translate(-1349 -6141) translate(-1 6036) translate(1350 105)" />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>

    )
}



// WEBPACK FOOTER //
// ./src/components/controls/icons/FacebookIcon.jsx